import React, { useContext, useEffect, useRef, useState } from "react";
import "../../assets/css/rcTree.css";
import Tree from "rc-tree";
import { useSelector, useDispatch } from "react-redux";
import { clone, cloneDeep, each } from "lodash";
import { treeActions } from "../../redux/slices/treeSlice";
import { api } from "../../redux/api";
//import DragDropTemplate from "../ContextMenu/InboundTemplateActions/DragDropTemplate";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import TreeLoading from "./TreeLoading";
import { eachDeep } from "deepdash-es/standalone";
import { getSelectedNodes, getStartAndEndKey } from "../RightContextMenu/ContextActions/CopyAndPaste";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { useTranslation } from "react-i18next";
import { getUpdatedData } from "../RightContextMenu/ContextActions/NewRecordOutbound";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import ErrorModal from "../ItemProperties/Forms/FieldDataValidation/ErrorModal";
import { addNodesAndUpdateTransData, nodesValidation, removeNodesAndUpdateTransData } from "../../utils/nodesValidation";
import { scrollToSelectedItem, scrollToMappedNode, customDecoding } from "../../utils/utilFunctions";
import { collectNodes, getKeys, getNodeParentsByKey } from "./InboundTemplateTree";
import { getSameLevelOrAboveLevelNode } from "./WorkflowGroupsTree";
import { getNodeParentsById } from "./InboundTemplateTree";
import Delete from "../RightContextMenu/ContextActions/Delete";
import GraphQLQueryEditor from "./GraphQLQueryEditor";

export default function OutboundTemplateTree(props) {
	const { expandActions } = props;
	const treeParentRef = React.createRef();
	const treeContainerRef = useRef(null);
	const manualClick = useRef(false);
	const { t } = useTranslation();
	const [show, setShow] = useState(false);
	const [draggedWfg, setDraggedWfg] = useState();
	const { account } = useSelector((state) => state.queryParams);
	const [selectedNodes, setSelectedNodes] = useState({});
	const [fromOnExpand, setFromOnExpand] = useState(false);
	const [modalContent, setModalContent] = useState("");
	const parentScreen = useContext(ParentScreenCtx);
	const [draggedNodes, setDraggedNodes] = useState([]);
	const [dropZoneHover, setDropZoneHover] = useState(false);
	const { leftTree, rightTree, recentlyVisitedTemplates } = useSelector(
		(state) => state.treeData.outbound
	);
	const mappingStates = useSelector((state) => state.treeData.mappingStates);
	const { workflowGroup, title } = leftTree.tree.body.selectedNode;
	const translatedData = rightTree.tree[props.tab].translatedData;
	const currentTab = rightTree.currentTab;
	const selectedNode = rightTree.tree[props.tab].selectedNode;
	const templateHeader = rightTree.tree.templateHeader;
	const dispatch = useDispatch();
	// const treeRef  = useRef(null);
	const treeRef = React.createRef();
	const [selectedKeys, setSelectedKeys] = useState([]);
	const [expandedKeys, setExpandedKeys] = useState({});
	const [treeDisabled, setTreeDisabled] = useState(false);
	const [treeFocused, setTreeFocused] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [draggedNodesPending, setDraggedNodesPending] = useState(); // This state will be used for storing nodes until user select any option in modal;
	const [errorModal, setErrorModal] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [showDeleteModal, setShowDeleteModal] = useState(false);

	const templatePath = `${account}/${workflowGroup}/${title}.json`;

	//updates provided state with proper map, using an array of ids
	const updateNodesByIds = (ids, setState) => {
		let nodes = {};
		each(ids, (id) => {
			getNodeById(translatedData, id, (item) => {
				nodes[id] = item.key;
			});
		})
		setState(nodes);
	}

	//updates provided state with proper map, using an array of keys
	const updateNodesByKeys = (keys, setState, isExpand) => {
		let nodes = {}
		let keysToExpand = []
		each(keys, (key) => {
			getNodeByKey(translatedData, key, (item) => {
				if (nodes?.hasOwnProperty(item.nodeId)){
					nodes[`${item.nodeId}_1`] = key;
					if (isExpand) keysToExpand.push(key);
				}
				else{
					if (isExpand) keysToExpand.push(key);
					nodes[item.nodeId] = key;
				}
			});
		})

		return setState(isExpand ? keysToExpand : nodes);
	}

	const modifyRecentVisitedTemplates = (node, tab) => {

		if (node) {
			const { key } = node;
			let isModified = false;
			let templates = [];

			// Check if the node exists and update its position
			templates = recentlyVisitedTemplates.map(o => {
				if (o.path === templatePath) {
					if (o.key !== key && o.tab === tab) {
						isModified = true;
						return { path: templatePath, key: key, tab: tab };
					}
					return o;
				}
				return o;
			});

			// If the node doesn't exist, add it to the array
			if (!recentlyVisitedTemplates.some(o => o.path === templatePath && o.tab === tab) && key && (key !== translatedData[0]?.key)) {
				templates.push({ path: templatePath, key: key, tab: tab });
				isModified = true;
			}

			// Dispatch the action only if the array has been modified
			if (isModified) {
				dispatch(treeActions.setRecentlyVisitedTemplates({
					screen: parentScreen,
					value: templates
				})
				)
			}
		}
	};
	
	const onExpand = (keys, detail) => {
		updateNodesByKeys(keys, setExpandedKeys, true);
		//Removing Selected Node if its Parent Node is shrink
		if (selectedNode?.key?.includes(detail.node.key) && !detail.expanded) {
			setFromOnExpand(true);
			// Use the current tab from Redux state to maintain consistency
			const targetTab = props.tab;
			dispatch(
				treeActions.setRightTreeSelectedNode({
					screen: parentScreen,
					type: targetTab,
					data: detail.node,
				})
			);
			setSelectedKeys((prev) =>
				selectedKeys.filter((ele) => !ele?.includes(detail.node.key))
			);
			setSelectedKeys((prev) => [...prev, detail.node.key]);
		}
	};

	// Ref to track the timeout for clearing lastRightTreeSelectionTime
	const selectionTimeoutRef = useRef(null);

	const onSelect = (keys, data) => {
		// Clear any existing timeout before setting new selection time
		if (selectionTimeoutRef.current) {
			clearTimeout(selectionTimeoutRef.current);
		}
		
		// Set the right tree selection time IMMEDIATELY to prevent unwanted tab changes
		const immediateSelectionTime = Date.now().toString();
		sessionStorage.setItem('lastRightTreeSelectionTime', immediateSelectionTime);
		
		// TODO: find correct way to focus the tree when user clicks on it. (for using arrow keys and enter button, etc.)
		//treeRef.current.focus();
		// Added metaKey for the MACOS
		manualClick.current = true;
		let kb = {
			shift: data.nativeEvent ? data.nativeEvent.shiftKey : false,
			ctrl: data.nativeEvent ? data.nativeEvent.ctrlKey : false,
			metaKey: data.nativeEvent ? data.nativeEvent.metaKey : false,
		};

		if (!kb.ctrl && !kb.shift && !kb.metaKey) {
			setSelectedKeys((prev) => [data.node.key]);
		} else if ((kb.ctrl || kb.metaKey) && !kb.shift) {
			setSelectedKeys((prev) => (keys.length !== 0 ? keys : [data.node.key]));
		}
		if (kb.shift) {
			// this could get complicated
			// write a function that selects all nodes by key from LAST selected node to
			// CURRENT selected node in a linear way. Selecting cross-depth will need to be handled.
			if (keys.length > 1) {
				const data = rightTree.tree[currentTab].translatedData;
				const selectedKeys = getShiftSelectedKeys(keys, data);
				setSelectedKeys(selectedKeys);
			}
		}

		// Unselecting Node first (Some Component is using Ag-grid which is making closure with states) So by unselecting it is Unmonunting whole component completely;
		
		modifyRecentVisitedTemplates(data.node, currentTab)
		
		// Auto-switch left tree tab if there's a cross-tab mapping for this target node
		

		
		let isCrossTabNavigation = false;
		
		if (mappingStates.isMappingMode) {
			const allMappings = [...(mappingStates.mappings || []), ...(mappingStates.automaticMappings || [])];
			
			const mappingsForNode = allMappings.filter(mapping => 
				mapping.targetKey === data.node.key || mapping.targetKey === String(data.node.key)
			);
			
			if (mappingsForNode.length > 0) {
				// Find the source tab for the first mapping
				const firstMapping = mappingsForNode[0];
				const sourceTabIndex = firstMapping.sourceTab;
				

				
				// Check if this is a cross-tab navigation
				if (sourceTabIndex !== undefined && sourceTabIndex >= 0 && sourceTabIndex <= 2 && sourceTabIndex !== props.tab) {
					isCrossTabNavigation = true;

					
					// Store the source node key for expansion and scrolling
					sessionStorage.setItem('crossTabSourceNodeKey', firstMapping.sourceKey);
					// Store the right tree selection time to prevent unwanted tab changes
					sessionStorage.setItem('lastRightTreeSelectionTime', Date.now().toString());
					
					// Switch left tree to the source tab using the setMiddleCurrTab prop
					if (props.setMiddleCurrTab) {

						props.setMiddleCurrTab(sourceTabIndex);

					} else {

					}
					
					
				} else if (sourceTabIndex !== undefined && sourceTabIndex >= 0 && sourceTabIndex <= 2) {
					
				} else {
					
				}
			} else {
				
			}
		} else {
			
		}
		
		
		// Always dispatch to Redux to maintain proper state
		
		// Clear the right tree selection time after 3 seconds to allow manual tab changes
		selectionTimeoutRef.current = setTimeout(() => {
			sessionStorage.removeItem('lastRightTreeSelectionTime');
			selectionTimeoutRef.current = null;
		}, 3000);
		
		// Always dispatch to the current tab in Redux state to maintain consistency
		const targetTab = props.tab;

		
			
			
		dispatch(
			treeActions.setRightTreeSelectedNode({
				screen: parentScreen,
				type: targetTab, // Use the current tab from Redux state
				data: {
					
					avoidSelection: true,
				},
			})
		);
		setTimeout(() => {
			dispatch(
				treeActions.setRightTreeSelectedNode({
					screen: parentScreen,
					type: targetTab, // Use the current tab from Redux state
					data: {
						...data.node,
						avoidSelection: true,
						isCrossTabNavigation: true, // Flag to identify this as cross-tab
					},
				})
			);

		});
		

	};

	// Add HTML5 drag and drop event listeners for external drops
	useEffect(() => {
		const treeContainer = treeContainerRef.current;
		
		// Always add event listeners when in mapping mode, regardless of translatedData content
		if (treeContainer && mappingStates.isMappingMode && !mappingStates.isLinkMode) {

			
			// Add event listeners for HTML5 drag and drop
			treeContainer.addEventListener('dragover', handleDragOver);
			treeContainer.addEventListener('dragenter', handleDragEnter);
			treeContainer.addEventListener('dragleave', handleDragLeave);
			treeContainer.addEventListener('drop', handleDropEvent);
			
			// Cleanup function to remove event listeners
			return () => {

				treeContainer.removeEventListener('dragover', handleDragOver);
				treeContainer.removeEventListener('dragenter', handleDragEnter);
				treeContainer.removeEventListener('dragleave', handleDragLeave);
				treeContainer.removeEventListener('drop', handleDropEvent);
			};
		}
	}, [mappingStates.isMappingMode, mappingStates.isLinkMode, mappingStates.dragData]); // Removed translatedData dependency

	// Add event listeners to the drop zone with the same handlers as the tree
	useEffect(() => {
		const dropZoneElements = document.querySelectorAll('.tree-drop-zone, .empty-tree-drop-zone');
		
		if (mappingStates.isMappingMode && !mappingStates.isLinkMode) {
			dropZoneElements.forEach(dropZone => {
				dropZone.addEventListener('dragover', handleDragOver);
				dropZone.addEventListener('dragenter', handleDragEnter);
				dropZone.addEventListener('dragleave', handleDragLeave);
				dropZone.addEventListener('drop', handleDropEvent);
			});
			
			// Cleanup function to remove event listeners
			return () => {
				dropZoneElements.forEach(dropZone => {
					dropZone.removeEventListener('dragover', handleDragOver);
					dropZone.removeEventListener('dragenter', handleDragEnter);
					dropZone.removeEventListener('dragleave', handleDragLeave);
					dropZone.removeEventListener('drop', handleDropEvent);
				});
			};
		}
	}, [mappingStates.isMappingMode, mappingStates.isLinkMode, mappingStates.dragData, translatedData]);

	useEffect(() => {

		
		// Use the current tab from Redux state to maintain consistency
		const targetTab = rightTree.currentTab || props.tab;
		dispatch(
			treeActions.setSelectedKeysArray({
				screen: parentScreen,
				type: targetTab, // Use the current tab from Redux state
				data: selectedKeys,
			})
		);

		
		// Sync with mapping states if in mapping mode
		if (mappingStates.isMappingMode) {

			
			// Get the selected nodes data for mapping
			const selectedNodes = selectedKeys.map(key => {
				let nodeData = null;
				getNodeByKey(translatedData, key, (item) => {
					nodeData = item;
				});
				return nodeData;
			}).filter(node => node);
			

			
			// Update mapping states with selected target nodes
			// Use the current tab from Redux state to maintain consistency
			const currentTabName = targetTab;
			
			if (currentTabName) {

				
				dispatch(treeActions.setMappingSelectedTargetNodes({
					tab: currentTabName,
					selectedNodes: selectedNodes
				}));

				
			} else {

			}
		}
		
		if (!manualClick.current) scrollToSelectedItem(selectedKeys, treeParentRef);
		manualClick.current = false;
	}, [selectedKeys, mappingStates.isMappingMode, props.tab, dispatch, translatedData]);

	// Monitor Redux state changes for debugging


	// Listen for AI auto-mapping tree selection updates
	useEffect(() => {
		const handleTreeSelectionUpdate = (event) => {
			const { tab, selectedKeys: newSelectedKeys } = event.detail;
			// Only update if this is the correct tab
			if (tab === props.tab) {
				setSelectedKeys(newSelectedKeys);
			}
		};

		window.addEventListener('updateTreeSelection', handleTreeSelectionUpdate);
		
		return () => {
			window.removeEventListener('updateTreeSelection', handleTreeSelectionUpdate);
		};
	}, [props.tab]);

	const formatModalContent = (string) => {
		let splitText = string.split(`\\n`);

		return (
			<>
				{splitText[0]}
				<br /><br />
				{splitText[2]}
				<br />
				{splitText[3]} <br />
			</>
		)
	};

	const onDragStart = (info) => {
		info.event.dataTransfer.effectAllowed = "move"
		const draggedNodes = selectedKeys?.filter(e => e === info.node.key)?.length
			? (getSelectedNodes(selectedKeys, translatedData, true) || [])?.map(e => e?.key)
			: (getSelectedNodes([info.node.key], translatedData, true) || [])?.map(e => e?.key);
		setDraggedNodes(draggedNodes);
	};

	const handleDialogShow = (modalText) => {
		setModalContent(formatModalContent(modalText));
		setShowModal(true);
	};


	// HTML5 drag and drop event handlers for external drops
	const handleDragOver = (event) => {
		// Allow drop by preventing default behavior
		event.preventDefault();
		event.dataTransfer.dropEffect = 'copy';
		
		// Remove previous highlights
		const previouslyHighlighted = document.querySelectorAll('.drop-target-hover');
		previouslyHighlighted.forEach(el => {
			el.classList.remove('drop-target-hover');
			el.style.backgroundColor = '';
			el.style.transition = '';
		});
		
		// If there's no tree data, highlight the empty tree drop zone
		if (!translatedData?.length) {
			const emptyDropZone = document.querySelector('.empty-tree-drop-zone');
			const treeContainer = document.getElementById('ob-tree');
			
			if (emptyDropZone) {
				emptyDropZone.classList.add('drop-target-hover');
				emptyDropZone.style.backgroundColor = '#e6f7ff';
				emptyDropZone.style.transition = 'background-color 0.2s ease-in-out';
				emptyDropZone.style.borderColor = '#1890ff';
			} else if (treeContainer) {
				// Fallback to highlighting the tree container
				treeContainer.classList.add('drop-target-hover');
				treeContainer.style.backgroundColor = '#e6f7ff';
				treeContainer.style.transition = 'background-color 0.2s ease-in-out';
			}
			return;
		}
		
		// Find the target element with data-key attribute (existing logic for when tree has data)
		let targetElement = event.target;
		let attempts = 0;
		const maxAttempts = 10; // Prevent infinite loops
		
		while (targetElement && !targetElement.getAttribute('data-key') && attempts < maxAttempts) {
			targetElement = targetElement.parentElement;
			attempts++;
			
			// Stop at tree container to avoid going too far up
			if (targetElement && targetElement.id === 'ob-tree') {
				break;
			}
		}
		
		if (targetElement && targetElement.getAttribute('data-key')) {
			const dataKey = targetElement.getAttribute('data-key');
			
			// Find the tree node row element to highlight the entire row
			// Try multiple strategies to find the best element to highlight
			let treeNodeRow = null;
			
			// Strategy 1: Find the closest .rc-tree-treenode
			treeNodeRow = targetElement.closest('.rc-tree-treenode');
			
			// Strategy 2: If no tree node found, find the content wrapper
			if (!treeNodeRow) {
				const contentWrapper = targetElement.closest('.rc-tree-node-content-wrapper');
				treeNodeRow = contentWrapper?.parentElement;
			}
			
			// Strategy 3: If still not found, look for parent div that contains the tree structure
			if (!treeNodeRow) {
				let parent = targetElement.parentElement;
				while (parent && parent !== document.getElementById('ob-tree')) {
					if (parent.classList.contains('rc-tree-treenode') || 
						parent.querySelector('.rc-tree-switcher')) {
						treeNodeRow = parent;
						break;
					}
					parent = parent.parentElement;
				}
			}
			
			// Use the tree node row for highlighting, fallback to target element
			const elementToHighlight = treeNodeRow || targetElement;
			
			
			// Add visual feedback to the entire row - only background, no layout changes
			elementToHighlight.classList.add('drop-target-hover');
			elementToHighlight.style.backgroundColor = '#e6f7ff';
			elementToHighlight.style.transition = 'background-color 0.2s ease-in-out';
			
		} else {
			

		}
	};

	const handleDragEnter = (event) => {
		event.preventDefault();
		
		// Add a class to the tree container to indicate drag is active
		const treeContainer = document.getElementById('ob-tree');
		if (treeContainer && mappingStates.isMappingMode && !mappingStates.isLinkMode) {
			treeContainer.classList.add('tree-drag-active');
			
		}
	};

	const handleDragLeave = (event) => {
		// Only remove highlighting if we're actually leaving the tree area
		// Check if the related target (where we're going) is outside the tree
		const treeContainer = document.getElementById('ob-tree');
		const relatedTarget = event.relatedTarget;
		
		if (!treeContainer || !treeContainer.contains(relatedTarget)) {
			// We're leaving the tree area, remove all highlights
			const highlightedElements = document.querySelectorAll('.drop-target-hover');
			highlightedElements.forEach(el => {
				el.classList.remove('drop-target-hover');
				el.style.backgroundColor = '';
				el.style.transition = '';
			});
			
		}
	};


	const getUpdatedNodesForOutbound = (draggedSourceNodes) => {
		
		const loopNode = (node) => {
			const cloneNode = cloneDeep(node);
			if (cloneNode.ICON_DISPLAY === "RECORD" || cloneNode.ICON_DISPLAY === "QUERY" || ((cloneNode.ICON_DISPLAY ===  "ELEMENT" && cloneNode?.children?.length) || cloneNode.ICON_DISPLAY ===  "REPEATING_ELEMENT")) {
				if (cloneNode.ICON_DISPLAY) delete cloneNode.ICON_DISPLAY;
				if (cloneNode.hasOwnProperty("QUERY")) delete cloneNode.QUERY;
				if (cloneNode.hasOwnProperty("CLAUSE")) delete cloneNode.CLAUSE;
				if (cloneNode.hasOwnProperty("PREDEFINED")) delete cloneNode.PREDEFINED;
				cloneNode.ICON_DISPLAY = "RECORD_LOOP";
				cloneNode.SOURCE_TYPE = "INBOUND_DATA";
				cloneNode.LOOP_SOURCE_NAME = cloneNode?.RECORD_TYPE || cloneNode?.TYPE;
				cloneNode.DESCRIPTION = cloneNode?.TYPE;
				cloneNode.PARENT = (cloneNode?.PARENT);
				cloneNode.title = `${t("LBL_RECORD")} ${cloneNode?.TYPE}`;
				cloneNode.EMPTY_ACTION = "EMPTY";
				cloneNode.RECORD_TYPE = cloneNode?.RECORD_TYPE;
				cloneNode.LOOP = "MULTI";
				["FIELD"].forEach(e => {
					if (cloneNode.hasOwnProperty(e)) delete cloneNode[e]
				})
				if (templateHeader?.FILETYPE === "XML") {
					cloneNode.ELEMENT_NAME = cloneNode?.MAPNAME || cloneNode?.TYPE;
				}
				if (cloneNode?.hasOwnProperty("ELEMENT_NAME") && templateHeader?.FILETYPE !== "XML") delete cloneNode.ELEMENT_NAME;
				if (cloneNode?.hasOwnProperty("ATTRIBUTE_NAME") && templateHeader?.FILETYPE !== "XML") delete cloneNode.ATTRIBUTE_NAME;
			}else if (cloneNode.ICON_DISPLAY === "FIELD" || cloneNode.ICON_DISPLAY === "ATTRIBUTE" || (cloneNode.ICON_DISPLAY ===  "ELEMENT" && !cloneNode?.children?.length)) {
				cloneNode.ICON_DISPLAY = (cloneNode.ICON_DISPLAY === "ATTRIBUTE" && templateHeader?.FILETYPE === "XML") ? "ATTRIBUTE" : "FIELD";
				cloneNode.SOURCE_TYPE = "INBOUND_DATA";
				cloneNode.RECORD_TYPE = cloneNode?.RECORD_TYPE;
				cloneNode.title =  `${t("LBL_FIELD")} ${cloneNode?.DESCRIPTION || cloneNode?.MAPNAME || cloneNode?.TYPE}`;
				cloneNode.PARENT = (cloneNode?.PARENT);
				cloneNode.FILLCHAR = cloneNode?.FILLCHAR || " ";
				if (templateHeader?.FILETYPE === "JSON") {
					cloneNode.QUOTE_DATA = "TRUE";
				}
				if (cloneNode?.hasOwnProperty("ELEMENT_NAME") && templateHeader?.FILETYPE !== "XML") delete cloneNode.ELEMENT_NAME;
				if (cloneNode?.hasOwnProperty("ATTRIBUTE_NAME") && templateHeader?.FILETYPE !== "XML") delete cloneNode.ATTRIBUTE_NAME;
			}else if (cloneNode.ICON_DISPLAY === "FIELD_LOOP"){
				cloneNode.ICON_DISPLAY = "FIELD_LOOP";
				cloneNode.SOURCE_TYPE = "INBOUND_DATA";
				cloneNode.RECORD_TYPE = cloneNode?.RECORD_TYPE;
				cloneNode.FILLCHAR = cloneNode?.FILLCHAR || " ";
				cloneNode.title =  `${t("LBL_FIELD")} ${cloneNode?.DESCRIPTION || cloneNode?.MAPNAME || cloneNode?.TYPE}`;
				cloneNode.REPEATING = "TRUE";
				cloneNode.SOURCE_REPEATING_FIELD = "TRUE";
				cloneNode.PARENT = (cloneNode?.PARENT);
			}
			else if (cloneNode.ICON_DISPLAY.includes("FIELD_GROUP")){
				if(!["HL7","EDI", "DELIM_FLD_ID", "MULIT_DELIMITED"].includes(templateHeader?.FILETYPE)){
					cloneNode.ICON_DISPLAY = "RECORD_LOOP";
					cloneNode.SOURCE_TYPE = "INBOUND_DATA";
					cloneNode.LOOP_SOURCE_NAME = cloneNode?.RECORD_TYPE || cloneNode?.TYPE;
					cloneNode.DESCRIPTION = cloneNode?.TYPE;
					cloneNode.PARENT = (cloneNode?.PARENT);
					cloneNode.title = `${t("LBL_RECORD")} ${cloneNode?.TYPE}`;
					cloneNode.EMPTY_ACTION = "EMPTY";
					cloneNode.RECORD_TYPE = cloneNode?.RECORD_TYPE;
					cloneNode.LOOP = "MULTI";
					["EDIT_RULE"].forEach(e => {
						if (cloneNode.hasOwnProperty(e)) delete cloneNode[e]
					})
				}else {
					cloneNode.ICON_DISPLAY = "FIELD_GROUP";
					cloneNode.title =  `${t('FIELD_GROUP')} ${cloneNode?.DESCRIPTION || cloneNode?.MAPNAME || cloneNode?.TYPE}`;
					cloneNode.FIELD_GROUP = "TRUE";
					cloneNode.DESCRIPTION = cloneNode?.DESCRIPTION || cloneNode?.MAPNAME || cloneNode?.TYPE;
					cloneNode.EMPTY_ACTION = "EMPTY";
					["RECORD_TYPE", "MAPNAME", "PARENT", "LENGTH", "TYPE"].forEach(e => {
						if (cloneNode.hasOwnProperty(e)) delete cloneNode[e]
					})
					cloneNode.EDIT_RULE = [
						{
							"TYPE" : cloneNode?.EDIT_RULE?.[0]?.TYPE || "RECORD_RULE"
						}
					];
				}
				
			}else if (cloneNode.ICON_DISPLAY === "REPEATING_FIELD_GROUP"){
				cloneNode.DESCRIPTION = cloneNode?.DESCRIPTION || cloneNode?.MAPNAME || cloneNode?.TYPE;
				cloneNode.ICON_DISPLAY = "REPEATING_FIELD_GROUP";
				cloneNode.SOURCE_TYPE = "INBOUND_DATA";
				cloneNode.RECORD_TYPE = cloneNode?.RECORD_TYPE;
				cloneNode.LOOP_SOURCE_NAME = cloneNode?.MAPNAME || cloneNode?.TYPE;
				cloneNode.PARENT = customDecoding(cloneNode?.PARENT);
				cloneNode.FIELD_GROUP = "TRUE";
				cloneNode.EMPTY_ACTION = "EMPTY";
				cloneNode.title =  `${t("FIELD_GROUP")} ${cloneNode?.DESCRIPTION || cloneNode?.MAPNAME || cloneNode?.TYPE}`;
				cloneNode.REPEATING = "TRUE";
				cloneNode.EDIT_RULE = [
					{
						"TYPE" : cloneNode?.EDIT_RULE?.[0]?.TYPE || "RECORD_RULE"
					}
				];
				
			}

			cloneNode.children = (cloneNode.children || []).map(loopNode);
			return cloneNode;
		}

		return draggedSourceNodes.map(node => {
			const updatedNode = loopNode(node);
			return updatedNode;
		});
	};

	const handleDropEvent = (event) => {
		event.preventDefault();
		// Check if this is a drop on the drop zone
		const isDropZone = event.target.classList.contains('tree-drop-zone') || 
						   event.target.classList.contains('empty-tree-drop-zone') ||
						   event.target.closest('.tree-drop-zone') ||
						   event.target.closest('.empty-tree-drop-zone');
		// Get the drag data from Redux instead of dataTransfer
		const draggedSourceNodes = mappingStates.dragData;
		if (draggedSourceNodes && mappingStates.isMappingMode && !mappingStates.isLinkMode) {
			// For drop zone, we don't need to find a target node
			let targetNode = null;
			let targetKey = null;
			
			if (!isDropZone) {
				// Multiple strategies to identify the target node (only for tree drops)
				let currentElement = event.target;
				while (currentElement && !targetKey) {
					targetKey = currentElement.getAttribute('data-key');
					if (!targetKey) {
						currentElement = currentElement.parentElement;
					}
				}
				
				// Strategy 2: If data-key not found, try to find the closest tree node element
				if (!targetKey) {
					const treeNode = event.target.closest('.rc-tree-treenode');
					if (treeNode) {
						// Look for data-key in child elements
						const keyElement = treeNode.querySelector('[data-key]');
						if (keyElement) {
							targetKey = keyElement.getAttribute('data-key');
						}
					}
				}
				
				// Strategy 3: Use the tree node's data attributes if available
				if (!targetKey) {
					const treeNode = event.target.closest('.rc-tree-treenode');
					if (treeNode) {
						// rc-tree typically adds data-key to the tree node itself
						targetKey = treeNode.getAttribute('data-key');
					}
				}
				
				// Find the actual node data using the key
				if (targetKey) {
					getNodeByKey(translatedData, targetKey, (node) => {
						targetNode = node;
					});
				}
			}
			
			// Clean up any visual feedback and drag states
			const dropTargetElements = document.querySelectorAll('.drop-target-hover');
			dropTargetElements.forEach(el => {
				el.classList.remove('drop-target-hover');
				el.style.backgroundColor = '';
				el.style.transition = '';
			});
			
			// Remove tree drag active state
			const treeContainer = document.getElementById('ob-tree');
			if (treeContainer) {
				treeContainer.classList.remove('tree-drag-active');
			}
			
			const updatedNodesForOutbound = getUpdatedNodesForOutbound(draggedSourceNodes.nodes);
			const tempTranslatedData = rightTree.tree[currentTab]?.translatedData || [];
			// Process the external drop with the identified target
			// Allow drop if there's a target node OR if translatedData is empty (no data case) OR if it's drop zone
			if (targetNode || !tempTranslatedData?.length || isDropZone) {
				// Handle the case when translatedData is empty (no existing data) or drop zone
				if (!tempTranslatedData?.length) {
					// Validate the data structure before calling addNodesAndUpdateTransData
					const validatedNodes = updatedNodesForOutbound.filter(node => {
						if (typeof node !== 'object' || node === null) {
							console.warn("Invalid node found (not an object):", node);
							return false;
						}
						return true;
					});
					
					if (validatedNodes.length === 0) {
						console.error("No valid nodes to add");
						dispatch(treeActions.clearDragData());
						return;
					}
					
					// When there's no existing data or dropping on zone, directly add the nodes without validation
					const {
						translatedData: newTreeData,
						selectedNode: finalNode,
						newSelectedKeys,
					} = addNodesAndUpdateTransData(
						tempTranslatedData || [], // use existing data or empty array
						validatedNodes, // use validated nodes instead
						null, // no target node for drop zone
						false, // not inside since no target for drop zone
						templateHeader?.FILETYPE,
						currentTab,
						parentScreen
					);
					updateNewData(newTreeData, finalNode, newSelectedKeys, true);
				} else {
					// Existing logic for when there's existing data and a target node (tree drops)
					if (isDropZone) {
						const rightTreeData = rightTree.tree[currentTab]?.translatedData || [];
						const targetNode = rightTreeData?.[0]?.children?.[rightTreeData?.[0]?.children?.length - 1] || rightTreeData[0]; // Use last node as target for drop zone
						const isInside = rightTreeData?.[0]?.children?.[rightTreeData?.[0]?.children?.length - 1] ? false : true; // If there's at least one child, add after it, else add inside
						const validatedNodes = updatedNodesForOutbound.filter(node => {
							if (typeof node !== 'object' || node === null || node?.ICON_DISPLAY === "TEMPLATE_BODY_DOTS") {
								console.warn("Invalid node found (not an object):", node);
								return false;
							}
							return true;
						});
						const {
							translatedData: newTreeData,
							selectedNode: finalNode,
							newSelectedKeys,
						} = addNodesAndUpdateTransData(
							rightTreeData,
							validatedNodes,
							targetNode,
							isInside,
							templateHeader?.FILETYPE,
							currentTab,
							parentScreen
						);
						updateNewData(newTreeData, finalNode, newSelectedKeys, true);
					}else {
						const { errorMessage, modalMessage, isInside } = nodesValidation(
							targetNode,
							updatedNodesForOutbound,
							currentTab,
							true,
							templateHeader?.FILETYPE,
							translatedData,
							parentScreen
						);
	
						if (modalMessage) {
							handleDialogShow(t(modalMessage));
							const selectedNodes = getSelectedNodes([targetNode.key], translatedData, true); // If dropped on IF node so it should also consider else node
							setDraggedNodesPending({ updatedData: translatedData, removedNodes: updatedNodesForOutbound, node: selectedNodes });
						} else if (errorMessage) {
							setErrorMessage(t(errorMessage));
							setErrorModal(true);
						} else if (!showModal && !errorMessage) {
							const {
								translatedData: newTreeData,
								selectedNode: finalNode,
								newSelectedKeys,
							} = addNodesAndUpdateTransData(
								tempTranslatedData,
								updatedNodesForOutbound,
								targetNode,
								isInside,
								templateHeader?.FILETYPE,
								currentTab,
								parentScreen
							);
							updateNewData(newTreeData, finalNode, newSelectedKeys, true);
							
						}
						
					}
				}
				dispatch(treeActions.clearDragData());
			} else {
				dispatch(treeActions.clearDragData());
			}
		} else {
			dispatch(treeActions.clearDragData());
		}
	};

	//handle drop event
	const onDrop = (info) => {
		// Store original target position before removal for proper insertion calculation
		const originalTargetKey = info.node.key;
		const originalTargetNodeId = info.node.nodeId;
		const originalTargetIconDisplay = info.node.ICON_DISPLAY;
		
		// Handle internal drag and drop (existing functionality)
		const { updatedData, removedNodes } = removeNodesAndUpdateTransData(
			translatedData,
			draggedNodes,
			parentScreen,
			templateHeader?.FILETYPE,
			true,
			currentTab
		);
		
		// Find the target node in the updated data (after removal/reindexing)
		let updatedTargetNode = null;
		const findUpdatedTarget = (data) => {
			data.forEach(node => {
				if (node.nodeId === originalTargetNodeId && node.ICON_DISPLAY === info.node.ICON_DISPLAY) {
					updatedTargetNode = node;
					return;
				}
				if (node.children) findUpdatedTarget(node.children);
			});
		};
		findUpdatedTarget(updatedData);
		
		const targetNode = updatedTargetNode || info.node;
		
		const { errorMessage, modalMessage, isInside } = nodesValidation(
			targetNode,
			removedNodes,
			currentTab,
			true,
			templateHeader?.FILETYPE,
			updatedData,
			parentScreen
		);



		if (modalMessage) {
			handleDialogShow(t(modalMessage));
			const selectedNodes = getSelectedNodes([targetNode.key], updatedData, true); // Use updated target node
			setDraggedNodesPending({ updatedData, removedNodes, node: selectedNodes || targetNode, originalTargetKey, originalTargetIconDisplay });
		} else if (errorMessage) {
			setErrorMessage(t(errorMessage));
			setErrorModal(true);
		} else if (!showModal && !errorMessage) {
			const {
				translatedData,
				selectedNode: finalNode,
				newSelectedKeys,
			} = addNodesAndUpdateTransData(
				updatedData,
				removedNodes,
				targetNode,
				isInside,
				templateHeader?.FILETYPE,
				currentTab,
				parentScreen
			);
			updateNewData(translatedData, finalNode, newSelectedKeys);
		}
	};

	const handleItemDrop = (isInside) => {
		const { updatedData, removedNodes, node, originalTargetIconDisplay } = draggedNodesPending;
		
		// Fix: Use the original target information to determine correct destination
		let destinationNode;
		let insertInside;
		
		if (node?.length === 2) {
			// Check which node was the actual drop target using originalTargetIconDisplay
			const targetIsElse = originalTargetIconDisplay === 'CONDITION_ELSE';
			
			if (targetIsElse) {
				// User dropped on ELSE node
				if (isInside) {
					// Yes - Insert inside ELSE node
					destinationNode = node[1];
					insertInside = true;
				} else {
					// No - Insert after IF node (before ELSE)
					destinationNode = node[0];
					insertInside = false;
				}
			} else {
				// User dropped on IF node
				if (isInside) {
					// Yes - Insert inside IF node
					destinationNode = node[0];
					insertInside = true;
				} else {
					// No - Insert after ELSE node (after the entire IF/ELSE block)
					destinationNode = node[1];
					insertInside = false;
				}
			}
		} else {
			destinationNode = node[0] || node;
			insertInside = isInside;
		}
		
		const { translatedData, selectedNode, newSelectedKeys } = addNodesAndUpdateTransData(updatedData, removedNodes, destinationNode, insertInside, templateHeader?.FILETYPE, currentTab, parentScreen);
		updateNewData(translatedData, selectedNode, newSelectedKeys);
		setShowModal(false);
	};

	const updateNewData = (finalData, finalNode, newSelectedKeys, isDropZone) => {
		const newUpdatedData = getUpdatedData(finalData, templateHeader?.FILETYPE, null, parentScreen === 'workflow', currentTab);
		// Use the current tab from Redux state to maintain consistency
		const targetTab = isDropZone ? currentTab : props.tab;
		// Dispatching Empty Node first will clear all states in Middle Panel and then dispatching original node
		dispatch(
			treeActions.setRightTreeSelectedNode({
				screen: parentScreen,
				type: targetTab,
				data: {},
			})
		);
		setTimeout(() => {
			dispatch(
				treeActions.setRightTreeSelectedNode({
					screen: parentScreen,
					type: targetTab,
					data: { ...finalNode },
				})
			);
		})
		setSelectedKeys([finalNode?.key]);
		dispatch(
			treeActions.setRightTreeTransData({
				screen: parentScreen,
				type: currentTab,
				data: newUpdatedData,
			})
		);
		modifyRecentVisitedTemplates(finalNode, props.tab)
	};

	const onRightClick = (info) => {
		// Fixed for not unselecting multiple nodes.
		if (!selectedKeys.includes(info.node.key) || selectedKeys.length < 2) {
			// Use the current tab from Redux state to maintain consistency
			const targetTab = props.tab;
			dispatch(
				treeActions.setRightTreeSelectedNode(
					cloneDeep({
						screen: parentScreen,
						type: targetTab,
						data: {
							avoidSelection: true,
						},
					})
				)
			);
			setTimeout(() => {
				dispatch(
					treeActions.setRightTreeSelectedNode(
						cloneDeep({
							screen: parentScreen,
							type: targetTab,
							data: {
								...info.node,
								avoidSelection: true,
							},
						})
					)
				);
			});
			setSelectedKeys([info.node.key]);
		}
	};

	// Handle double-click to scroll to mapped nodes
	const onDoubleClick = (info) => {
		if (!mappingStates.isMappingMode) {
			return;
		}
		
		// Check if info is a SyntheticEvent (direct event from Tree component)
		let clickedNodeKey;
		if (info && info.nativeEvent && info.target) {
			// This is a SyntheticEvent, extract node key from the target element
			// Try multiple approaches to find the data-key
			let targetElement = info.target.closest('[data-key]');
			if (!targetElement) {
				// Try looking for rc-tree-treenode
				targetElement = info.target.closest('.rc-tree-treenode');
				if (targetElement) {
					const keyElement = targetElement.querySelector('[data-key]');
					if (keyElement) {
						targetElement = keyElement;
					}
				}
			}
			if (!targetElement) {
				// Try looking in parent elements more broadly
				let current = info.target;
				while (current && current !== document.body) {
					if (current.hasAttribute && current.hasAttribute('data-key')) {
						targetElement = current;
						break;
					}
					if (current.querySelector) {
						const found = current.querySelector('[data-key]');
						if (found) {
							targetElement = found;
							break;
						}
					}
					current = current.parentElement;
				}
			}
			
			if (targetElement) {
				clickedNodeKey = targetElement.getAttribute('data-key');
			} else {
				return;
			}
		} else if (info && info.node && info.node.key) {
			// This is a proper node info object
			clickedNodeKey = info.node.key;
		} else {
			return;
		}
		
		if (!clickedNodeKey) {
			return;
		}
		
		const tabMapping = ['header', 'body', 'trailer'];
		const currentTabIndex = tabMapping.indexOf(props.tab);
		
		// Call the utility function to scroll to mapped nodes
		scrollToMappedNode(
			clickedNodeKey, 
			mappingStates.mappings, 
			mappingStates.automaticMappings, 
			false, // isSourceTree = false (this is target tree)
			currentTabIndex
		);
	};

	const translatedDataKeys = getKeys(translatedData);
	const collectedNodes = collectNodes(translatedData);

	const handleKeyDown = (event) => {
		event.preventDefault();
		const expandAndCollapseNode = (isExpand) => {
			if (selectedNode?.children?.length && isExpand && !Object.values(expandedKeys)?.filter(e => e === selectedNode.key)?.length) {
				updateNodesByKeys([...Object.values(expandedKeys), selectedNode.key], setExpandedKeys, true);
			} else if (selectedNode?.children?.length && !isExpand && Object.values(expandedKeys)?.filter(e => e === selectedNode.key)?.length) {
				updateNodesByKeys(Object.values(expandedKeys).filter(e => e !== selectedNode.key), setExpandedKeys, true);
			}
		}

		const navigate = (offset) => {
			if (selectedNodes.length === 0) return;
			const currentIndex = translatedDataKeys.reduce((acc, ele, index) => ele?.key === selectedKeys[0] ? index : acc, 0);
			let newIndex = currentIndex + offset;
			let nextNodeKey = translatedDataKeys[newIndex]?.key;
			let nextNode = collectedNodes[nextNodeKey];
			const sameLevelOrAboveLevelNodeIndex = getSameLevelOrAboveLevelNode(translatedDataKeys, selectedNode?.key, currentIndex, offset);
			if ((!Object.values(expandedKeys)?.filter(e => e === selectedNode.key)?.length && nextNodeKey?.indexOf(selectedNode?.key) !== -1)
				|| (!Object.values(expandedKeys)?.filter(e => e === translatedDataKeys[sameLevelOrAboveLevelNodeIndex]?.key)?.length && nextNodeKey?.indexOf(translatedDataKeys[sameLevelOrAboveLevelNodeIndex]?.key) !== -1 && offset === -1)
			) {
				nextNodeKey = translatedDataKeys[isNaN(sameLevelOrAboveLevelNodeIndex) ? currentIndex : sameLevelOrAboveLevelNodeIndex]?.key;
				nextNode = collectedNodes[nextNodeKey];
			}
			if (newIndex < 0 || newIndex >= translatedDataKeys.length || !nextNodeKey) {
				return;
			}

			// Use the current tab from Redux state to maintain consistency
			const targetTab = props.tab;
			updateNodesByKeys([nextNodeKey], setSelectedNodes);
			dispatch(
				treeActions.setRightTreeSelectedNode({
					screen: parentScreen,
					type: targetTab,
					data: {},
				})
			);
			setTimeout(() => {
				dispatch(
					treeActions.setRightTreeSelectedNode({
						screen: parentScreen,
						type: targetTab,
						data: nextNode,
					})
				);
			})

		};
		if (event.key === "ArrowUp") {
			navigate(-1);
		} else if (event.key === "ArrowDown") {
			navigate(1);
		} else if (event.key === "ArrowRight") {
			expandAndCollapseNode(true);
		} else if (event.key === "ArrowLeft") {
			expandAndCollapseNode(false);
		} else if ((event.key === "Delete") && selectedKeys.length > 0) {
			// Trigger delete modal when Delete or Backspace key is pressed and there are selected items
			setShowDeleteModal(true);
		}

	};

	const handleAIAction = (node, isThumbUpButtonClicked) => {
		const updatedData = eachDeep(cloneDeep(translatedData), (objValue) => {
            if (objValue?.key !== node?.key) {
                return;
            }
            if (isThumbUpButtonClicked) {
				if (objValue?.hasOwnProperty("AI_CONFIDENCE"))
					delete objValue.AI_CONFIDENCE;
				objValue.AI_USER_CONFIRMED = "TRUE";
			} else {
				[
					"AI_CONFIDENCE",
					"MAPNAME",
					"PARENT",
					"SOURCE_TYPE",
					"RECORD_TYPE",
					"AI_USER_CONFIRMED"
				].forEach((e) => {
					if (objValue?.hasOwnProperty(e)) delete objValue[e];
				});
			}
			// Use the current tab from Redux state to maintain consistency
			const targetTab = props.tab;
			// Dispatching Empty Node first will clear all states in Middle Panel and then dispatching original node
			dispatch(treeActions.setRightTreeSelectedNode({
				screen: parentScreen,
				type: targetTab,
				data: {avoidSelection: true},
			}))
			setTimeout(() => {
				dispatch(
					treeActions.setRightTreeSelectedNode({
						screen: parentScreen,
						type: targetTab,
						data: objValue,
					})
				);
			})

        });
        dispatch(
            treeActions.setNewRightTreeTranslatedData({
              screen: parentScreen,
              type: props.tab,
              data: updatedData,
            })
        );
	}

	useEffect(() => {
		// Expand Parent Node and Select Child Node if It is Updated in Redux (Required for Creating New Node).
		if (selectedNode?.key) {
			
			if (
				selectedNode.key &&
				!selectedKeys.filter(e => e === selectedNode?.key)?.length &&
				!selectedNode?.avoidSelection
			) {
				setSelectedKeys((prev) => [selectedNode.key]);
				modifyRecentVisitedTemplates(selectedNode, props.tab)

			}
		}

		const updateExpNodes = () => {
			//filter duplicate expand ids caused by reindexing
	        let prevExpanded = Object.values(expandedKeys); // Store previous expanded nodes
			
			// Get alternateNodeIds of previously expanded nodes
			const expandedAltNodeIds = [];
			prevExpanded.forEach(key => {
				eachDeep(translatedData, (node) => {
					if (node && typeof node === 'object' && node?.key === key && node?.alternateNodeId) {
						expandedAltNodeIds.push(node.alternateNodeId);
					}
				});
			});
			
			// Find nodes with matching alternateNodeIds in updated tree
			const restoredKeys = [];
			expandedAltNodeIds.forEach(altNodeId => {
				eachDeep(translatedData, (node) => {
					if (node && typeof node === 'object' && node?.key && node?.alternateNodeId === altNodeId) {
						restoredKeys.push(node.key);
					}
				});
			});
			
			let filteredENI = [...new Set([...prevExpanded, ...restoredKeys])];
			if (selectedNode?.key) {
				if (filteredENI.length === 0 && selectedNode?.key === translatedData[0]?.key) {
					// If the selected node is the first node, expand the first node
					filteredENI.push(selectedNode?.key);
				}
				//if current selected node is inside a non-expanded parent, expand the parent to show the node.
				getNodeParentsByKey(translatedData, selectedNode.key, (parentIdsArray = []) => {
					updateNodesByKeys([...new Set([...filteredENI, ...parentIdsArray])], setExpandedKeys, true)
				});
			} else {
				//else update expanded nodes with filtered arr
				updateNodesByKeys(filteredENI, setExpandedKeys, true);
			}
		}

		!fromOnExpand && updateExpNodes();
		setFromOnExpand(false);
	}, [translatedData, selectedNode?.key]);



	useEffect(() => {
		if (
			rightTree?.treeActions?.expandKeys?.length &&
			rightTree?.treeActions?.treeType === currentTab
		) {
			// const values = Object.values(expandedNodes || {});
			const values = Object.values(expandedKeys);
			const filteredKeys = rightTree?.treeActions?.expandKeys?.filter(
				(e) => !values.includes(e)
			);
			const newExpandedKeys = [...values, ...filteredKeys];
			updateNodesByKeys(newExpandedKeys, setExpandedKeys, true);
			dispatch(treeActions.setTreeActions({ data: {} })); // Clearing TreeActions after executing actions;
		}
	}, [rightTree?.treeActions]);

	useEffect(() => {
		const updateSelectedNodeInRightTree = (visitedTemplates, templatePath, tab) => {
			// Find the node in recentlyVisitedTemplates that matches the templatePath
			const matchedTemplate = visitedTemplates.find(template => (template.path === templatePath) && (template.tab === tab));
			if (!matchedTemplate) {
				return translatedData[0]; // Return first node if no matching template is found in list of recently visited templates
			}

			let matchingNode = null;
			// Traverse translatedData to find the matching node by pos
			eachDeep(cloneDeep(rightTree.tree[props.tab].translatedData), (obj) => {
				if (obj && typeof obj === 'object' && obj?.key === matchedTemplate.key) {
					matchingNode = obj;
					return false;
				}
				if (Array.isArray(obj?.children)) {
					return obj.children;
				}
			});

			return matchingNode; // Return the matching node
		};

		if (leftTree.tree.body.selectedNode?.type === 'outboundTemplate') {
			if (
				(props.tab === "body" ||
					rightTree.tree[props.tab].translatedData.length)
			) {
				const matchingNode = updateSelectedNodeInRightTree(
					recentlyVisitedTemplates,
					templatePath,
					props.tab
				) || rightTree?.tree?.[props.tab]?.translatedData?.[0] || {};
				setSelectedKeys([matchingNode?.key]);
				// setExpandedKeys([matchingNode?.key])
				// Use the current tab from Redux state to maintain consistency
				dispatch(
					treeActions.setRightTreeSelectedNode({
						screen: parentScreen,
						type: props.tab, // Use the current tab from Redux state
						data: {
							
							avoidSelection: true,
						},
					})
				);
				setTimeout(() => {
					dispatch(
						treeActions.setRightTreeSelectedNode({
							screen: parentScreen,
							type: props.tab, // Use the current tab from Redux state
							data: {
								...matchingNode,
								avoidSelection: true,
								isCrossTabNavigation: true, // Flag to identify this as cross-tab
							},
						})
					);
				});
			}
			else {
				setSelectedKeys([]);
				setExpandedKeys({});
				// Use the current tab from Redux state to maintain consistency
				const targetTab = props.tab;
				dispatch(
					treeActions.setRightTreeSelectedNode({
						screen: parentScreen,
						type: targetTab,
						data: {},
					})
				);
			}
		}

	}, [leftTree.tree.body.selectedNode?.key, templateHeader?.FILETYPE, templateHeader?.FILETYPE_VERSION, rightTree.loading])


	useEffect(() => {
		// if (!rightTree.loading && leftTree.tree.body.selectedNode?.type === "outboundTemplate") {
		// 	if (translatedData?.length !== 0 && props.tab === "body") {
		// 		updateNodesByKeys([translatedData[0]?.key || "ob"], setExpandedKeys, true);
		// 	}
		// 	// props.tab === "body" && setExpandedKeys(translatedData?.length !== 0 ? updateNodesByKeys([translatedData[0]?.key], setExpandedKeys) : {});
		// 	setSelectedKeys((prev) => translatedData?.length ? [translatedData[0]?.key] : []);
		// 	// dispatch(
		// 	// 	treeActions.setRightTreeSelectedNode({
		// 	// 		screen: parentScreen,
		// 	// 		type: props.tab,
		// 	// 		data: translatedData?.[0] || {},
		// 	// 	})
		// 	// )
		// }

	}, [leftTree.tree.body.selectedNode?.key]);



	useEffect(() => {
		if (expandActions?.tab === props.tab) {
			const keys = Object?.values(expandActions.keys) || [];
			updateNodesByKeys(keys, setExpandedKeys, true);
		}
	}, [expandActions]);

	// Handle expansion requests from mapping functionality
	useEffect(() => {
		const expansionRequest = mappingStates.expansionRequests.rightTree[props.tab];
		if (mappingStates.isMappingMode && expansionRequest) {
			const keysToExpand = expansionRequest.keys || expansionRequest; // Support both old and new format
			
			if (Array.isArray(keysToExpand) && keysToExpand.length > 0) {
				// Get current expanded keys
				const currentExpanded = Object.values(expandedKeys);
				const newKeysToExpand = keysToExpand.filter(key => !currentExpanded.includes(key));
				
				if (newKeysToExpand.length > 0) {
					const allKeys = [...currentExpanded, ...newKeysToExpand];
					updateNodesByKeys(allKeys, setExpandedKeys, true);
				}
				
				// Clear the expansion request after processing
				dispatch(treeActions.clearExpansionRequest({
					tree: 'rightTree',
					tab: props.tab
				}));
			}
		}
	}, [mappingStates.expansionRequests.rightTree[props.tab], mappingStates.isMappingMode, props.tab, dispatch]);

	// Handle custom events for cross-tab navigation from source tree double-clicks
	useEffect(() => {
		const handleScrollToMappedNode = (event) => {
			const { type, tab, targetKey } = event.detail;
			
			if (type === 'switchTargetTab') {
				const tabMapping = ['header', 'body', 'trailer'];
				const targetTabName = tabMapping[tab];
				
				// Check if this is the correct tab
				if (props.tab === targetTabName) {
					// Switch to this tab and scroll to the target node
					
					// Scroll to the target node after tab switch
					setTimeout(() => {
						const targetContainer = document.getElementById('ob-tree');
						if (targetContainer) {
							const targetElement = targetContainer.querySelector(`[data-key="${targetKey}"]`);
							if (targetElement) {
								// Use scrollToSelectedItem utility for consistent scrolling  
								const treeContainer = targetElement.closest('.overflow-auto');
								if (treeContainer) {
									scrollToSelectedItem([targetKey], { current: treeContainer });
								} else {
									targetElement.scrollIntoView({ 
										behavior: 'smooth', 
										block: 'start',
										inline: 'nearest'
									});
								}
								
								// Add highlight effect
								targetElement.style.backgroundColor = '#e6f7ff';
								targetElement.style.transition = 'background-color 0.3s ease';
								setTimeout(() => {
									targetElement.style.backgroundColor = '';
								}, 1500);
							}
						}
					}, 200);
				}
			}
		};
		
		window.addEventListener('scrollToMappedNode', handleScrollToMappedNode);
		
		return () => {
			window.removeEventListener('scrollToMappedNode', handleScrollToMappedNode);
		};
	}, [props.tab, dispatch, parentScreen]);

	const titleRenderHandler = (node) => {

		if (node.AI_CONFIDENCE) {

			let confidenceColor = "aic-red";

			//convert the decimal string to a percentage string, and also set the associated color
			function processConfidenceVal(decimalString) {
				let val = parseFloat(decimalString);
				
				// 3-color system based on value
				if (val < 0.5) confidenceColor = " red-badge";
				else if (val < 0.75) confidenceColor = " orange-badge";
				else confidenceColor = " green-badge";
				
				return Math.trunc(parseFloat(decimalString) * 100) + "%";
			}
			
			const confidenceVal = processConfidenceVal(node.AI_CONFIDENCE);

			return (
				<span 
					data-key={`${node.key}`}
					title={
						node.ICON_DISPLAY === "PLUGIN" ? node.PLUGIN_DESCRIPTION : node.title
					}
					className="full-width-tree-node-row"
				>
					<div
						style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
					>
						<span>{node.title}</span>
						<div
							style={{
								
								right: "0px", 
								display: "flex",
								gap: "5px",
								paddingLeft: "8px",
								paddingRight: "16px",
								position: "absolute", 
								alignItems: "center", 
								backgroundColor: "#FFF",
								height: "20px",
								width: "80px",
							}}
						>
							<div style={{width: "33px"}}><div className={"aic" + confidenceColor}>{confidenceVal}</div></div>
							<div onClick={(event) => {
								event.stopPropagation();
								handleAIAction(node, true)
							}} className="ai-thumb-icon">
								<span className="THUMB_UP"></span>
							</div>
							<div onClick={(event) => {
								event.stopPropagation();
								handleAIAction(node, false)
							}} className="ai-thumb-icon">
								<span className="THUMB_DOWN"></span>
							</div>
						</div>
					</div>
				</span>
				
			);
		} else {
			return (
				<span
					data-key={`${node.key}`}
					title={
						node.ICON_DISPLAY === "PLUGIN" ? node.PLUGIN_DESCRIPTION : node.DESCRIPTION || node.title
					}
				>
					{node.title}
				</span>
			);
		}

		
	};

	const Icon = (node) => {
		if (
			[
				"FIELD",
				"ELEMENT",
				"ATTRIBUTE",
				"FIELD_LOOP",
				"DATABASE_FIELD",
				"DATABASE_FIELD_KEY",
				"DATABASE_FIELD_VALID",
				"DATABASE_FIELD_VALID_KEY"
			].includes(node?.ICON_DISPLAY) &&
			((node.FIELDTYPE && node.FIELDTYPE !== "CONSTANT") ||
				node.hasOwnProperty("FIELD")
				? node?.FIELD?.FIELDTYPE !== "CONSTANT"
				: false) &&
			(!node.data?.hasOwnProperty("RECORD_TYPE") ||
				!node.data?.hasOwnProperty("MAPNAME") ||
				node?.data?.MAPNAME === t("SELECT"))
		) {
			let iconDisplay = "WARNING";

			// Check if it's mapped - if not, keep WARNING icon
			if (node.data?.hasOwnProperty("RECORD_TYPE") && 
				node.data?.hasOwnProperty("MAPNAME") && 
				node?.data?.MAPNAME !== t("SELECT")) {
				// Only set database icons if the field is properly mapped
				if (
					["DATABASE_FIELD", "DATABASE_FIELD_KEY", "DATABASE_FIELD_VALID", "DATABASE_FIELD_VALID_KEY"].includes(node.ICON_DISPLAY) ||
					(templateHeader?.FILETYPE === "DATABASE" && node.ICON_DISPLAY === "FIELD")
				) {
					if (
						node.UNIQUE === "TRUE" &&
						node.KEY === "TRUE"
					) {
						iconDisplay = "DATABASE_FIELD_VALID_KEY";
					} else if (node.UNIQUE === "TRUE") {
						iconDisplay = "DATABASE_FIELD_VALID";
					} else if (node.KEY === "TRUE") {
						iconDisplay = "DATABASE_FIELD_KEY";
					} else {
						iconDisplay = "DATABASE_FIELD";
					}
				}
			}

			//XML header/trailer uses CSV node types for display, even though the data stays the same.
			if (templateHeader?.FILETYPE === "XML" && ["header", "trailer"].includes(props.tab)) {
				//identify "element" nodes that need to look like record.
				if (node?.ICON_DISPLAY === "ELEMENT") iconDisplay = "RECORD";
				if (node?.ICON_DISPLAY === "REPEATING_ELEMENT") iconDisplay = "RECORD_LOOP";
				//identify "attribute" nodes that need to look like field.
				if (!node?.hasOwnProperty("FIELD") && (!node?.hasOwnProperty("ICON_DISPLAY") || node?.ICON_DISPLAY === "FIELD")) {
					if (node.data.hasOwnProperty("RECORD_TYPE") && node.data.hasOwnProperty("MAPNAME")) {
						iconDisplay = "FIELD";
					}
				}
			}
			if (templateHeader?.FILETYPE === "XML" && props.tab === "body" && node?.ICON_DISPLAY) {
				//constant - give normal icon
				if (node?.FIELDTYPE === "CONSTANT" || node?.FIELD?.FIELDTYPE === "CONSTANT") {
					iconDisplay = node?.ICON_DISPLAY;
				} else if (node?.ICON_DISPLAY === "ELEMENT" && node?.XML_RECORD === "TRUE") {
					//record - give record icon
					iconDisplay = "RECORD_LOOP";
				}
				else if (node?.FIELD) {
					///if element has the FIELD property, and if it is mapped, apply its assigned icon
					if (node?.FIELD?.MAPNAME && node?.FIELD?.RECORD_TYPE) {
						iconDisplay = node?.ICON_DISPLAY;
					}
				}
			}
			if (node?.hasOwnProperty("AI_CONFIDENCE")) iconDisplay = "AI_CONFIDENCE";

			return <span className={"tree-icon " + iconDisplay}></span>;
		} else {
			let iconDisplay = node.ICON_DISPLAY;
			if (node.ICON_DISPLAY === "QUERY" && node.TYPE === "QUERY") {
				iconDisplay = "CUSTOM_FIELD";
			}
			else if (
				["DATABASE_FIELD", "DATABASE_FIELD_KEY", "DATABASE_FIELD_VALID", "DATABASE_FIELD_VALID_KEY"].includes(node.ICON_DISPLAY) ||
				(templateHeader?.FILETYPE === "DATABASE" &&
					node.ICON_DISPLAY === "FIELD")
			) {
				if (
					node.UNIQUE &&
					node.UNIQUE === "TRUE" &&
					node.KEY &&
					node.KEY === "TRUE"
				) {
					iconDisplay = "DATABASE_FIELD_VALID_KEY";
				} else if (node.UNIQUE && node.UNIQUE === "TRUE") {
					iconDisplay = "DATABASE_FIELD_VALID";
				} else if (node.KEY && node.KEY === "TRUE") {
					iconDisplay = "DATABASE_FIELD_KEY";
				} else {
					iconDisplay = "DATABASE_FIELD";
				}
			}
			//XML header/trailer uses CSV node types for display
			if (templateHeader?.FILETYPE === "XML" && ["header", "trailer"].includes(props.tab)) {
				//identify "element" nodes that need to look like record.
				if (node?.ICON_DISPLAY === "ELEMENT") iconDisplay = "RECORD";
				if (node?.ICON_DISPLAY === "REPEATING_ELEMENT") iconDisplay = "RECORD_LOOP";
				//identify "attribute" nodes that need to look like field.
				if (!node?.hasOwnProperty("FIELD") && (!node?.hasOwnProperty("ICON_DISPLAY") || node?.ICON_DISPLAY === "FIELD")) {
					if (node.data.hasOwnProperty("RECORD_TYPE") && node.data.hasOwnProperty("MAPNAME")) {
						iconDisplay = "FIELD";
					}
				}
			} else if (node?.ICON_DISPLAY === "ELEMENT" && node?.XML_RECORD === "TRUE") {
				//record - give record icon
				iconDisplay = "RECORD_LOOP";
			}
			if (node?.hasOwnProperty("AI_CONFIDENCE")) iconDisplay = "AI_CONFIDENCE";
			return <span id={node.data.key} className={"tree-icon " + iconDisplay}></span>;
		}
	};

	const switcherIcon = (obj) => {
		if (obj.isLeaf) return;
		if (obj.expanded) return <ArrowDropDownIcon />;
		else return <ArrowRightIcon sx={{ color: "#666666" }} />;
	};

	return (
    <>
      <div
        ref={treeContainerRef}
        className="overflow-auto height-100"
        style={{
          userSelect: "none",
          height: "100%",
          minHeight: "200px", // Ensure minimum height for empty tree
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        id="ob-tree">
        {!rightTree.loading ? (
          <>
            {translatedData &&
            translatedData.length > 0 &&
            templateHeader?.FILETYPE !== "GraphQL" ? (
              <>
                <div style={{ flexShrink: 0 }}>
                  <Tree
                    focusable={true}
                    disabled={treeDisabled}
                    ref={treeRef}
                    className="myCls"
                    showLine
                    autoFocus
                    onExpand={onExpand}
                    onSelect={onSelect}
                    onDoubleClick={onDoubleClick}
                    treeData={translatedData}
                    draggable={true}
                    icon={Icon}
                    selectedKeys={selectedKeys}
                    expandedKeys={
                      expandedKeys ? Object.values(expandedKeys) : {}
                    }
                    multiple
                    showIcon
                    onDragStart={onDragStart}
                    onDrop={onDrop}
                    onRightClick={onRightClick}
                    switcherIcon={switcherIcon}
                    selectable={true}
                    titleRender={titleRenderHandler}
                    virtual={true}
                  />
                </div>
                {/* Drop zone below the tree */}
                <div
                  className="tree-drop-zone"
                  style={{
                    flex: 1,
                    minHeight: "100px",
                    marginTop: "2px",

                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    // backgroundColor: dropZoneHover ? "#f0f8ff" : "#fafafa",
                    color: dropZoneHover ? "#007acc" : "#999",
                    fontSize: "12px",
                    transition: "all 0.2s ease",
                    cursor:
                      mappingStates.isMappingMode && !mappingStates.isLinkMode
                        ? "copy"
                        : "default",
                    fontWeight: dropZoneHover ? "500" : "normal",
                  }}></div>
              </>
            ) : (
              // Render a placeholder when tree is empty to ensure drop area exists
              <div
                style={{
                  height: "100%",
                  minHeight: "200px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border:
                    mappingStates.isMappingMode && !mappingStates.isLinkMode
                      ? "2px dashed #ccc"
                      : "none",
                  borderRadius: "4px",
                  color: "#999",
                  fontSize: "14px",
                }}
                className="empty-tree-drop-zone">
                {mappingStates.isMappingMode && !mappingStates.isLinkMode ? (
                  t("MSSG_NO_DATA_MAPPING")
                ) : templateHeader?.FILETYPE === "GraphQL" ? (
                    <GraphQLQueryEditor />
                ) : (
                  t("MSSG_NO_DATA_NORMAL")
                )}
              </div>
            )}
          </>
        ) : (
          <TreeLoading />
        )}
      </div>
      <Dialog open={showModal}>
        <DialogTitle className="dialog-header title">
          <div className="title">{t("BOX_CONFIRM")}</div>
        </DialogTitle>
        <DialogContent className="dialog-content" dividers>
          <div className="alignToHeader">{modalContent}</div>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => handleItemDrop(true)}>
            {t("BTN_YES")}
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => handleItemDrop(false)}>
            {t("BTN_NO")}
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => {
              // toggle(null);
              setShowModal(false);
            }}>
            {t("BTN_CANCEL")}
          </Button>
        </DialogActions>
      </Dialog>
      <ErrorModal
        errorModal={errorModal}
        errorMessage={errorMessage}
        handleErrorModal={setErrorModal}
      />
      <Delete
        openModal={showDeleteModal}
        toggle={() => setShowDeleteModal(false)}
      />
    </>
  );
}

// Function to Get Shift Selection Keys;
const getShiftSelectedKeys = (keys, data) => {
	const firstKey = keys[keys.length - 2];
	const secondKey = keys[keys.length - 1];

	const { startKey, endKey } = getStartAndEndKey(firstKey, secondKey);
	const selectedKeys = [];
	eachDeep(data, (obj) => {
		const key = obj?.key;
		if (key && obj?.ICON_DISPLAY && checkValidKey(key, startKey, endKey)) {
			selectedKeys.push(key);
		}
	});
	return selectedKeys;

	function checkValidKey(key, startKey, endKey) {
		if (key === startKey || key === endKey) {
			return true;
		}

		const keyArray = key.split("-").splice(1);
		const startKeyArray = startKey.split("-").splice(1);
		const endKeyArray = endKey.split("-").splice(1);
		const keySize = keyArray.length;
		const startKeySize = startKeyArray.length;
		const endKeySize = endKeyArray.length;

		if (keySize < startKeySize) {
			// When Current Key is Smaller than Start Key Size and End Key Size
			if (keySize < endKeySize) {
				let isKeyValid1 = true;
				let isKeyValid2 = true;

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}
				if (startKey.includes(key)) isKeyValid1 = false;

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
				}
				if (key.includes(endKey)) isKeyValid2 = false;

				return isKeyValid1 && isKeyValid2;

				// When Current Key is Smaller than Start Key Size and greater than End Key Size
			} else if (keySize > endKeySize) {
				let isKeyValid1 = false;
				let isKeyValid2 = false;

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}
				if (startKey.includes(key)) isKeyValid1 = false;

				for (let i = 0; i < endKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
				}
				if (endKey.includes(key)) isKeyValid2 = true;

				return isKeyValid1 && isKeyValid2;

				// When Current Key is Smaller than Start Key Size and equal End Key Size
			} else if (keySize === endKeySize) {
				let isKeyValid1 = true;
				let isKeyValid2 = false;
				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}
				if (startKey.includes(key)) isKeyValid1 = false;

				for (let i = 0; i < endKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
				}
				return isKeyValid1 && isKeyValid2;
			}
		} else if (keySize > startKeySize) {
			// When Current Key is greater than Start Key Size and smaller than End Key Size
			if (keySize < endKeySize) {
				let isKeyValid1 = true;
				let isKeyValid2 = false;

				for (let i = 0; i < startKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}
				if (startKey.includes(key)) isKeyValid1 = true;

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
				}
				if (endKey.includes(key)) isKeyValid2 = true;

				return isKeyValid1 && isKeyValid2;

				// When Current Key is greater than Start Key Size and End Key Size
			} else if (keySize > endKeySize) {
				let isKeyValid1 = true;
				let isKeyValid2 = false;

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}
				if (startKey.includes(key)) isKeyValid1 = true;

				for (let i = 0; i < endKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
				}
				if (endKey.includes(key) && endKeySize > keySize) isKeyValid2 = false;

				return isKeyValid1 && isKeyValid2;

				// When Current Key is greater than Start Key Size and equal to End Key Size
			} else if (keySize === endKeySize) {
				let isKeyValid1 = true;
				let isKeyValid2 = false;

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}
				if (startKey.includes(key)) isKeyValid1 = true;

				for (let i = 0; i < endKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
				}
				if (endKey.includes(key) && endKeySize > keySize) isKeyValid2 = false;

				return isKeyValid1 && isKeyValid2;
			}
		} else {
			// When Current Key is equal to Start Key Size and smaller than End Key Size

			if (keySize < endKeySize) {
				let isKeyValid1 = true;
				let isKeyValid2 = true;

				for (let i = 0; i < startKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
				}
				if (endKeyArray.includes(key)) isKeyValid2 = true;

				return isKeyValid1 && isKeyValid2;

				// When Current Key is equal to Start Key Size and greater than End Key Size
			} else if (keySize > endKeySize) {
				let isKeyValid1 = false;
				let isKeyValid2 = false;

				for (let i = 0; i < startKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
				}

				return isKeyValid1 && isKeyValid2;

				// When Current Key is equal to Start Key Size and End Key Size
			} else if (keySize === endKeySize) {
				let isKeyValid1 = false;
				let isKeyValid2 = false;

				for (let i = 0; i < startKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
				}

				return isKeyValid1 && isKeyValid2;
			}
		}
	}
};

const getNodeParentsKeys = (key) => {
	if (!key) return [];
	const parentNodes = [];
	const keyArray = key.split("-");
	let tempKey = keyArray[0];
	for (let i = 1; i < keyArray.length; i++) {
		tempKey += `-${keyArray[i]}`;
		parentNodes.push(tempKey);
	}
	return parentNodes;
};

// loop through tree data, return callback with node info if id is found, and exit loop.
const getNodeById = (_data, id, _callback) => {
	let exitLoop = false;
	const loopNode = (data) => {
		each(data, (item, index, arr) => {
			if (exitLoop) return false;
			if (!item) return;
			if (item.nodeId === id) {
				exitLoop = true;
				return _callback(item, index, arr);
			}
			if (item.children) loopNode(item.children);
		})
	}
	return loopNode(_data);
};

// loop through tree data, return callback with node info if key is found, and exit loop.
const getNodeByKey = (_data, key, callback) => {
	let exitLoop = false;
	const loopNode = (data) => {
		each(data, (item, index, arr) => {
			if (exitLoop) return false;
			if (item.key === key) {
				exitLoop = true;
				return callback(item, index, arr);
			}
			if (item.children) loopNode(item.children);
		})
	}
	return loopNode(_data);
};